import { render, staticRenderFns } from "./StockPrintTicketTpl8.vue?vue&type=template&id=b9f0df4e&scoped=true&"
import script from "./StockPrintTicketTpl8.vue?vue&type=script&lang=js&"
export * from "./StockPrintTicketTpl8.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintTicketTpl8.vue?vue&type=style&index=0&id=b9f0df4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f0df4e",
  null
  
)

export default component.exports